import ImageView from 'dygc-ui/packages/image/src/image-viewer'
import { createPopup } from '@/assets/js/factory'

function handler(event) {
  const vm = createPopup(ImageView, {
    zIndex: 3000,
    initialIndex: 0,
    urlList: [event.target.src],
    onClose: () => {
      vm.$emit('close')
    }
  })
  event.preventDefault()
  event.stopPropagation()
}


function previewHandler(evt) {
  if (evt.target.tagName.toLowerCase() !== 'img') {
    return
  }
  handler(evt)
}

export function previewImage(el) {
  el.removeEventListener('click', previewHandler)
  el.addEventListener('click', previewHandler, true)
  // let imgList = el.getElementsByTagName('img')
  // for (let i = 0; i < imgList.length; i++) {
  //   const img = imgList[i]
  //   img.onclick = handler
  // }
}
